/*eslint-disable */

import Vue from 'vue'
import axios from 'axios';
import root from '../_helpers/roots';

let twoFactorOtpVerifyApiUrl = root.twoFactorOtpVerifyApiUrl.link;
let twoFactorOtpSendApiUrl = root.twoFactorOtpSendApiUrl.link;
export default {
  state: {
  },
  mutations: {
  },
  actions: {
    // Two Factor Otp Verify
    verifyTwoFactorOtp(context, payload) {
        return new Promise((resolve, reject) => {
            axios.post(twoFactorOtpVerifyApiUrl, payload).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    },
    // Two Factor Otp Send
    sendTwoFactorOtp(context, payload) {
        return new Promise((resolve, reject) => {
            axios.get(twoFactorOtpSendApiUrl + '?data_file_id=' + payload.id).then(res => {
                resolve(res);
            }).catch(err => {
                reject(err);
            })
        })
    }
  },
  getters: {
  }
}